module.exports = __webpack_public_path__ + "static/media/edit-icon.993a6e85.svg";